var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "./modules/components/modal", "./modules/services/customAxios", "./modules/services/toastNotification"], function (require, exports, modal_1, customAxios_1, toastNotification_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    customAxios_1 = __importDefault(customAxios_1);
    var modalSelectors = {
        btnCancelar: '#switch-modal-cancelar',
        btnConfirmar: '#switch-modal-confirmar',
        modalHeader: '#switch-modal-header',
        modalBody: '#switch-modal-body',
        modalClose: '#switch-modal-close'
    };
    var btnSwitchDataAdminMember = document.querySelector('#btnSwitchDataAdminMember');
    var spanSwitchModalCount = document.querySelector('#switch-modal-count');
    var txtSwitchModalSearchByDataAdministrator = document.querySelector('#txtSwitchModalSearchByDataAdministrator');
    var txtDataAdminId = document.querySelector("#txtSwitchModalDataAdminMemberId");
    var txtOperationCodeId = document.querySelector("#txtSwitchModalOperationCodeId");
    var switchModalForm = document.querySelector('#switchModalForm');
    var onLoad = function () {
        btnSwitchDataAdminMember === null || btnSwitchDataAdminMember === void 0 ? void 0 : btnSwitchDataAdminMember.addEventListener('click', openModal);
    };
    var openModal = function () { return __awaiter(void 0, void 0, void 0, function () {
        var modal, data, modalContent, e_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    closeOthersModal();
                    modal = new modal_1.Modal('#switch-data-admin-member-modal', modalSelectors);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, 4, 5]);
                    btnSwitchDataAdminMember === null || btnSwitchDataAdminMember === void 0 ? void 0 : btnSwitchDataAdminMember.setAttribute('disabled', 'disabled');
                    btnSwitchDataAdminMember === null || btnSwitchDataAdminMember === void 0 ? void 0 : btnSwitchDataAdminMember.classList.add('cursor-not-allowed');
                    return [4, customAxios_1.default.get('/backoffice/usuario/obter-bandeiras')];
                case 2:
                    data = (_d.sent()).data.data;
                    if (!data || data.length <= 0)
                        throw new Error('Usuário não possui bandeiras para trocar.');
                    setModalCount(data.length);
                    modalContent = (_a = data.map(function (item) { return "\n            <div class=\"switch-modal-choose border border-gray-400 cursor-pointer p-2 m-2 transition-all duration-150 ease-in-out\" data-admin-member-id=\"" + item.dataAdminMemberId + "\" data-op-code-id=\"" + item.operationCodeId + "\" data-admin-name=\"" + item.dataAdminName + "\">\n                <p class=\"text-sm w-full truncate\"><span class=\"font-bold\">Administradora: </span>" + item.dataAdminName + "</p>\n                <p class=\"text-sm w-full truncate\"><span class=\"font-bold\">Bandeira: </span>" + item.dataAdminMemberName + "</p>\n                <p class=\"text-sm w-full truncate\"><span class=\"font-bold\">Opera\u00E7\u00E3o: </span>" + item.operationCode + "</p>\n            </div>"; })) === null || _a === void 0 ? void 0 : _a.join('');
                    modal.AddContent(modalContent).AddConfirmButton(switchDataAdminMemberAndOpCode).Show();
                    txtSwitchModalSearchByDataAdministrator === null || txtSwitchModalSearchByDataAdministrator === void 0 ? void 0 : txtSwitchModalSearchByDataAdministrator.focus();
                    txtSwitchModalSearchByDataAdministrator === null || txtSwitchModalSearchByDataAdministrator === void 0 ? void 0 : txtSwitchModalSearchByDataAdministrator.addEventListener('keyup', searchByDataAdministrator);
                    (_b = document.querySelectorAll('.switch-modal-choose')) === null || _b === void 0 ? void 0 : _b.forEach(function (e) { return e.addEventListener('click', onChooseDataAdminMemberAndOpCode); });
                    return [3, 5];
                case 3:
                    e_1 = _d.sent();
                    toastNotification_1.ToastNotification.Error((_c = e_1 === null || e_1 === void 0 ? void 0 : e_1.message) !== null && _c !== void 0 ? _c : 'Não foi possível obter as bandeiras do usuário.');
                    console.error(e_1);
                    modal.Close();
                    return [3, 5];
                case 4:
                    btnSwitchDataAdminMember === null || btnSwitchDataAdminMember === void 0 ? void 0 : btnSwitchDataAdminMember.removeAttribute('disabled');
                    btnSwitchDataAdminMember === null || btnSwitchDataAdminMember === void 0 ? void 0 : btnSwitchDataAdminMember.classList.remove('cursor-not-allowed');
                    btnSwitchDataAdminMember === null || btnSwitchDataAdminMember === void 0 ? void 0 : btnSwitchDataAdminMember.classList.add('cursor-pointer');
                    return [7];
                case 5: return [2];
            }
        });
    }); };
    var onChooseDataAdminMemberAndOpCode = function () {
        clearSignInChoice();
        var dataAdminMemberId = this.dataset.adminMemberId;
        var opCodeId = this.dataset.opCodeId;
        if (!dataAdminMemberId || !opCodeId)
            toastNotification_1.ToastNotification.Alert('Falha ao selecionar bandeira.');
        txtDataAdminId.value = dataAdminMemberId !== null && dataAdminMemberId !== void 0 ? dataAdminMemberId : '';
        txtOperationCodeId.value = opCodeId !== null && opCodeId !== void 0 ? opCodeId : '';
        this.classList.add('switch-modal-chose');
    };
    var searchByDataAdministrator = function () {
        var _a, _b;
        clearSignInChoice();
        var searchInput = (_a = this.value) === null || _a === void 0 ? void 0 : _a.toUpperCase().trim();
        var count = 0;
        (_b = document.querySelectorAll('.switch-modal-choose')) === null || _b === void 0 ? void 0 : _b.forEach(function (el) {
            var _a;
            var dataAdminName = (_a = el.dataset.adminName) === null || _a === void 0 ? void 0 : _a.toUpperCase().trim();
            if (searchInput === '' || (dataAdminName === null || dataAdminName === void 0 ? void 0 : dataAdminName.includes(searchInput))) {
                el.setAttribute('style', 'display:block');
                count++;
            }
            else
                el.setAttribute('style', 'display:none');
        });
        setModalCount(count);
    };
    var switchDataAdminMemberAndOpCode = function () {
        var _a, _b;
        if (((_a = !(txtDataAdminId === null || txtDataAdminId === void 0 ? void 0 : txtDataAdminId.value)) !== null && _a !== void 0 ? _a : true) || ((_b = !(txtDataAdminId === null || txtDataAdminId === void 0 ? void 0 : txtDataAdminId.value)) !== null && _b !== void 0 ? _b : true)) {
            toastNotification_1.ToastNotification.Alert('Selecione a bandeira.');
            return;
        }
        switchModalForm === null || switchModalForm === void 0 ? void 0 : switchModalForm.submit();
    };
    var setModalCount = function (count) {
        spanSwitchModalCount.textContent = count > 1 ? "(" + count + ") bandeiras encontradas" : "(" + count + ") bandeira encontrada";
    };
    var clearSignInChoice = function () {
        var _a;
        (_a = document.querySelectorAll('.switch-modal-choose')) === null || _a === void 0 ? void 0 : _a.forEach(function (e) { return e.classList.remove('switch-modal-chose'); });
        txtDataAdminId.value = '';
        txtOperationCodeId.value = '';
    };
    var closeOthersModal = function () { return document.querySelectorAll('.standard-modal').forEach(function (el) { return el.classList.add('hidden'); }); };
    window.addEventListener('load', onLoad);
});
